import Page from "@jumbo/shared/Page";
import PlywoodExpenses from "app/pages/Master/ExpenseMaster/PlywoodExpenses";
import AddExpenses from "app/pages/Master/ExpenseMaster/PlywoodExpenses/AddExpenses";
import AccessMiddleware from "app/routes/middleware/auth/AccessMiddleware";

export const plywoodExpenseRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "expense_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/expense/plywood",
        element: <Page component={PlywoodExpenses} layout={"vertical-default"} />,
      },
      {
        path: "/master/expense/plywood/add/:invoiceId",
        element: <Page component={AddExpenses} layout={"vertical-default"} />,
      }
    ],
  },
];
